/**
 * When a previous (baseline) amount exists: waived = previous − current fee.
 * e.g. previous ₹600, processing ₹400 → `-₹200`.
 */
export function formatWaivedAmountFromPrevious(
  previousAmount: number | undefined | null,
  currentAmount: number,
  formatAmount: (amount: number) => string,
): string {
  const previous = Number(previousAmount);
  if (!Number.isFinite(previous) || previous <= 0) {
    return formatAmount(0);
  }
  const current = Number.isFinite(Number(currentAmount))
    ? Number(currentAmount)
    : 0;
  const waived = previous - current;
  if (waived <= 0) return formatAmount(0);
  return `-${formatAmount(waived)}`;
}

/**
 * Pick the current fee used for waived math when breakdown row and form state differ.
 */
export function resolveWaiverCurrentAmount(
  baseline: number,
  rowAmount: number,
  stateAmount: number,
): number {
  const base = Number.isFinite(baseline) ? baseline : 0;
  const row = Number.isFinite(rowAmount) ? rowAmount : 0;
  const state = Number.isFinite(stateAmount) ? stateAmount : 0;
  if (row === state) return row;
  if (state < base && state !== row) return state;
  if (row < base && row !== state) return row;
  return row;
}

/** @deprecated Use formatWaivedAmountFromPrevious */
export function computeFeeWaivedDelta(
  previousAmount: number,
  currentAmount: number,
): number {
  const prev = Number.isFinite(previousAmount) ? previousAmount : 0;
  const cur = Number.isFinite(currentAmount) ? currentAmount : 0;
  return Math.max(0, prev - cur);
}

export function formatFeeWaivedDeltaDisplay(
  previousAmount: number,
  currentAmount: number,
  formatAmount: (amount: number) => string,
): string {
  return formatWaivedAmountFromPrevious(
    previousAmount,
    currentAmount,
    formatAmount,
  );
}
